/**
 * Opens collapsed accordion and FAQ answers for printing and closes them again afterwards.
 *
 * Alpine hides them with x-show.important, i.e. an inline "display: none !important" - no print
 * stylesheet can override that. Everything else about the print layout is CSS (@media print in
 * app.css). Accordion-1 (#acc-c-…) and Faq-2 (#faq-a-…) are the collapsible variants.
 */
const COLLAPSIBLE = '[id^="acc-c-"], [id^="faq-a-"]';

export function registerPrintHelpers() {
    let opened = [];

    window.addEventListener('beforeprint', () => {
        opened = [];
        document.querySelectorAll(COLLAPSIBLE).forEach((el) => {
            opened.push([el, el.style.getPropertyValue('display'), el.style.getPropertyPriority('display')]);
            el.style.setProperty('display', 'block', 'important');
        });
    });

    window.addEventListener('afterprint', () => {
        opened.forEach(([el, value, priority]) => {
            if (value) {
                el.style.setProperty('display', value, priority);
            } else {
                el.style.removeProperty('display');
            }
        });
        opened = [];
    });
}
